<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
-->

<template>
  <div>
    <v-card
      class="app-team-selection elevation-5"
      :class="{ selected: value === 'SINGLE' }"
      @click.native="$emit('change', 'SINGLE')"
    >
      <v-card-title primary-title>
        <h1 class="headline w-100 d-flex justify-space-between">
          Single Team <span class="text-sm-right">$30/month</span>
        </h1>

        <span class="app-team-selection-description">
          Ideal for small organizations or organizations with only one team or
          department that need to use ExclusionCheck.
        </span>
      </v-card-title>
    </v-card>

    <v-card
      class="app-team-selection elevation-5 mt-4"
      :class="{ selected: value === 'MULTI_TEAM' }"
      @click.native="$emit('change', 'MULTI_TEAM')"
    >
      <v-card-title primary-title>
        <h1 class="headline w-100 d-flex justify-space-between">
          Unlimited Teams <span class="text-sm-right">$75/month</span>
        </h1>

        <span class="app-team-selection-description">
          Ideal for organizations with multiple teams, departments, or
          facilities that need to use ExclusionCheck.
        </span>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "TeamOptions",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.app-elevate {
  box-shadow: 0 6px 6px -3px rgba(0, 0, 0, 0.2),
    0 10px 14px 1px rgba(0, 0, 0, 0.14), 0 4px 18px 3px rgba(0, 0, 0, 0.12) !important;
}

.app-team-selection {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  user-select: none;
  max-width: 26.7rem;
  margin: 0 auto;

  h1 {
    font-weight: 700;
    font-size: 1rem !important;
    margin-bottom: 0;

    span {
      font-weight: normal;
    }
  }

  .app-team-selection-description {
    text-align: left;
  }

  &.selected {
    background-color: $color-ec-orange !important;
    color: $color-white !important;
    box-shadow: none !important;
    @extend .app-elevate;
  }

  &:not(.selected) {
    color: $color-ec-darker-gray;
    border: solid 1px $color-ec-dark-gray;
  }

  &:hover {
    cursor: pointer;
    @extend .app-elevate;
  }

  .v-card__title--primary {
    padding: 0.825rem 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TeamOptions.vue